var productSlider = new theme.Slideshow(document.querySelector('.product-slideshow'));

// Helper function to get visible slide indices
function getVisibleSlideIndices() {
  var visibleSlides = document.querySelectorAll('.product-main-slide:not(.hide)');
  return Array.from(visibleSlides).map(slide => parseInt(slide.getAttribute('data-index')));
}

// Store reference to check if we're in variant mode
function isInVariantMode() {
  return document.querySelector('.muz-product-media-main-parent.parent-slide-sect-active') !== null;
}

// Override Flickity navigation to loop within variant slides
if (productSlider && productSlider.slideshow) {
  var flickity = productSlider.slideshow;
  var isRedirecting = false;
  
  // Store original methods
  var originalNext = flickity.next.bind(flickity);
  var originalPrevious = flickity.previous.bind(flickity);
  var originalSelect = flickity.select.bind(flickity);
  
  // Override next
  flickity.next = function(isWrapping, isInstant) {
    if (!isInVariantMode()) {
      originalNext(isWrapping, isInstant);
      return;
    }
    
    var visibleIndices = getVisibleSlideIndices();
    if (visibleIndices.length === 0) {
      originalNext(isWrapping, isInstant);
      return;
    }
    
    var currentIndex = flickity.selectedIndex;
    var currentPos = visibleIndices.indexOf(currentIndex);
    
    if (currentPos !== -1) {
      var nextPos = (currentPos + 1) % visibleIndices.length;
      var nextIndex = visibleIndices[nextPos];
      flickity.select(nextIndex, false, isInstant);
    } else {
      flickity.select(visibleIndices[0], false, isInstant);
    }
  };
  
  // Override previous
  flickity.previous = function(isWrapping, isInstant) {
    if (!isInVariantMode()) {
      originalPrevious(isWrapping, isInstant);
      return;
    }
    
    var visibleIndices = getVisibleSlideIndices();
    if (visibleIndices.length === 0) {
      originalPrevious(isWrapping, isInstant);
      return;
    }
    
    var currentIndex = flickity.selectedIndex;
    var currentPos = visibleIndices.indexOf(currentIndex);
    
    if (currentPos !== -1) {
      var prevPos = currentPos === 0 ? visibleIndices.length - 1 : currentPos - 1;
      var prevIndex = visibleIndices[prevPos];
      flickity.select(prevIndex, false, isInstant);
    } else {
      flickity.select(visibleIndices[visibleIndices.length - 1], false, isInstant);
    }
  };
  
  // Override select to constrain to visible slides during drag
  flickity.select = function(index, isWrapping, isInstant) {
    if (!isInVariantMode() || isRedirecting) {
      originalSelect(index, isWrapping, isInstant);
      return;
    }
    
    var visibleIndices = getVisibleSlideIndices();
    if (visibleIndices.length === 0) {
      originalSelect(index, isWrapping, isInstant);
      return;
    }
    
    // If trying to select a hidden slide, redirect to appropriate visible slide
    if (!visibleIndices.includes(index)) {
      isRedirecting = true;
      var currentIndex = flickity.selectedIndex;
      var currentPos = visibleIndices.indexOf(currentIndex);
      
      if (currentPos !== -1) {
        // Determine direction of navigation
        if (index > currentIndex) {
          // Going forward, loop to start
          var targetIndex = visibleIndices[0];
        } else {
          // Going backward, loop to end
          var targetIndex = visibleIndices[visibleIndices.length - 1];
        }
        originalSelect(targetIndex, false, isInstant);
      } else {
        // Fallback: go to first visible
        originalSelect(visibleIndices[0], false, isInstant);
      }
      isRedirecting = false;
      return;
    }
    
    originalSelect(index, isWrapping, isInstant);
  };
  
  // Update thumbnail active state when slide changes
  flickity.on('change', function(index) {
    document.querySelectorAll('.product__thumb-item a').forEach(link => {
      link.classList.remove('is-active');
    });
    
    var thumbLink = document.querySelector('.product__thumb-item:not(.hide) a[data-index="' + index + '"]');
    if (thumbLink) {
      thumbLink.classList.add('is-active');
    }
  });
}

// Setup variant thumbnail handlers on initial load
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    setupVariantThumbnailHandlers();
  }, 200);
});

// Function to setup click handlers for variant thumbnails
function setupVariantThumbnailHandlers() {
  // Find all variant thumbnails (those with muz-thumb-var-data attribute)
  var variantThumbs = document.querySelectorAll('.product__thumb-item[muz-thumb-var-data] a[data-product-thumb]');
  
  variantThumbs.forEach(function(thumbLink) {
    // Remove any existing handlers by checking if already processed
    if (thumbLink.hasAttribute('data-muz-handler-setup')) return;
    thumbLink.setAttribute('data-muz-handler-setup', 'true');
    
    // Add click handler that prevents default and navigates slider
    thumbLink.addEventListener('click', function(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      var index = parseInt(thumbLink.getAttribute('data-index'));
      if (!isNaN(index) && productSlider && typeof productSlider.goToSlide === 'function') {
        productSlider.goToSlide(index);
      }
    }, false);
  });
}

// Function to calculate and set flickity-viewport height based on visible images
function setFlickityViewportHeight() {
  var viewport = document.querySelector('.muz-product-media-main-parent .flickity-viewport');
  if (!viewport) return;
  
  // Only set height if we're in variant-only mode (parent-slide-sect-active class exists)
  var parentElement = document.querySelector('.muz-product-media-main-parent.parent-slide-sect-active');
  if (!parentElement) {
    // Not in variant-only mode, let Flickity handle it normally
    if (productSlider && typeof productSlider.resize === 'function') {
      productSlider.resize();
    }
    return;
  }
  
  var mainPhotos = document.querySelector('.muz-product-media-main-parent .product__main-photos');
  if (!mainPhotos) return;
  
  var containerWidth = mainPhotos.offsetWidth;
  if (!containerWidth || containerWidth === 0) {
    // Try again after a short delay if width not available yet
    setTimeout(setFlickityViewportHeight, 50);
    return;
  }
  
  // Find the first visible active variant slide
  var activeSlide = document.querySelector('.muz-added-product-media.product-main-slide.muz-active-var.is-selected');
  if (!activeSlide) {
    // Fallback: find first visible variant slide
    activeSlide = document.querySelector('.muz-added-product-media.product-main-slide.muz-active-var');
  }
  
  // Function to set height based on aspect ratio
  function applyHeight(ratio) {
    var calculatedHeight = containerWidth / ratio;
    if (calculatedHeight > 0 && Math.abs(viewport.offsetHeight - calculatedHeight) > 1) { // Only update if significantly different
      viewport.style.height = calculatedHeight + 'px';
      // Resize flickity after setting height
      if (productSlider && typeof productSlider.resize === 'function') {
        productSlider.resize();
      }
    }
  }
  
  if (activeSlide) {
    var img = activeSlide.querySelector('.muzamil-image-media');
    if (img) {
      // Get aspect ratio from data attribute (default to 1.0 for square)
      var aspectRatio = parseFloat(img.getAttribute('data-aspectratio')) || 1.0;
      
      // If image is loaded, use its natural dimensions for more accurate calculation
      if (img.complete && img.naturalHeight > 0 && img.naturalWidth > 0) {
        aspectRatio = img.naturalWidth / img.naturalHeight;
        applyHeight(aspectRatio);
      } else {
        // Use data attribute aspect ratio immediately
        applyHeight(aspectRatio);
        
        // Then update when image loads for accuracy
        img.addEventListener('load', function() {
          if (img.naturalHeight > 0 && img.naturalWidth > 0) {
            var loadedAspectRatio = img.naturalWidth / img.naturalHeight;
            applyHeight(loadedAspectRatio);
          }
        }, { once: true });
      }
      return;
    }
  }
  
  // Fallback: use default square aspect ratio if no image found
  applyHeight(1.0);
}

// Function to handle variant selection logic
function handleVariantSelection(radio) {
  // Find the associated label element
  var label = document.querySelector(`label[for="${radio.id}"]`);
  var selectedDataValue = label ? label.getAttribute('muz-var-data') : null; // Get the custom attribute value

  if (selectedDataValue) {
    // Remove existing active classes
    document.querySelectorAll('.muz-active-var').forEach(el => el.classList.remove('muz-active-var'));
    document.querySelectorAll('.parent-slide-sect-active').forEach(el => el.classList.remove('parent-slide-sect-active'));
    document.querySelectorAll('.hide').forEach(el => el.classList.remove('hide')); // Remove all existing `.hide` classes

    // Add active class to the parent element
    var parentElement = document.querySelector('.muz-product-media-main-parent');
    if (parentElement) {
      parentElement.classList.add('parent-slide-sect-active');
    }

    // Add active class to all matching slides
    var allSlides = document.querySelectorAll('.product-main-slide');
    var targetSlides = document.querySelectorAll(`.product-main-slide[muz-slide-var-data="${selectedDataValue}"]`);
    if (targetSlides.length > 0) {
      targetSlides.forEach(slide => slide.classList.add('muz-active-var'));
      allSlides.forEach(slide => {
        // Add `.hide` to slides that are not active
        if (!slide.classList.contains('muz-active-var')) {
          slide.classList.add('hide');
        }
      });
    } else {
      console.warn(`No slides found for data value: ${selectedDataValue}`);
    }

    // Navigate to the first matching slide (for slider functionality)
    if (targetSlides.length > 0) {
      var slideIndex = parseInt(targetSlides[0].getAttribute('data-index')); // Get the slide index
      productSlider.goToSlide(slideIndex); // Navigate to the slide
    } else {
      productSlider.goToSlide(0); // Fallback behavior
    }

    // Add active class to all matching thumbnails
    var allThumbs = document.querySelectorAll('.product__thumb-item');
    var targetThumbs = document.querySelectorAll(`.product__thumb-item[muz-thumb-var-data="${selectedDataValue}"]`);
    if (targetThumbs.length > 0) {
      targetThumbs.forEach(thumb => thumb.classList.add('muz-active-var'));
      allThumbs.forEach(thumb => {
        // Add `.hide` to thumbnails that are not active
        if (!thumb.classList.contains('muz-active-var')) {
          thumb.classList.add('hide');
        }
      });
      
      // Setup handlers for newly visible variant thumbnails
      setTimeout(function() {
        setupVariantThumbnailHandlers();
        // Update active state on first visible thumbnail
        if (targetThumbs.length > 0 && targetSlides.length > 0) {
          var firstThumbLink = targetThumbs[0].querySelector('a[data-product-thumb]');
          if (firstThumbLink) {
            // Remove is-active from all thumbnails
            document.querySelectorAll('.product__thumb-item a').forEach(link => {
              link.classList.remove('is-active');
            });
            // Add is-active to first visible thumbnail
            firstThumbLink.classList.add('is-active');
          }
        }
        // Set viewport height for variant images
        setFlickityViewportHeight();
      }, 50);
    } else {
      console.warn(`No thumbnails found for data value: ${selectedDataValue}`);
    }

    // Manage flickity dots
    var allDots = document.querySelectorAll('.flickity-page-dots .dot');
    var targetIndexes = Array.from(targetSlides).map(slide => parseInt(slide.getAttribute('data-index')));

    allDots.forEach((dot, index) => {
      if (targetIndexes.includes(index)) {
        dot.style.display = 'inline-block'; // Show the dot if its index matches
      } else {
        dot.style.display = 'none'; // Hide the dot otherwise
      }
    });
  } else {
    console.warn('No muz-var-data attribute found on the associated label.'); 
    productSlider.goToSlide(0); // Fallback behavior
  }
}

// Add event listeners for both change and click events
document.querySelectorAll('.variant-input input[type="radio"]').forEach(radio => {
  // Handle change events (for multiple variants)
  radio.addEventListener('change', function () {
    handleVariantSelection(this);
  });
  
  // Handle click events (for single variants that are already selected)
  radio.addEventListener('click', function () {
    handleVariantSelection(this);
  });
});



// added by muzamil on 12 august 2025
// for the varinat based url for varinat speciifc metafield images 



(function() {
  // Reuse existing slideshow if defined by your code
  var productSliderEl = document.querySelector('.product-slideshow');
  if (!productSliderEl) return;

  // Parse variant map
  var mapEl = document.getElementById('muz-variant-map');
  if (!mapEl) return;
  var VARMAP = JSON.parse(mapEl.textContent);

  function getUrlVariantId() {
    var p = new URLSearchParams(location.search);
    var id = p.get('variant');
    return id ? parseInt(id, 10) : null;
  }
  function findVariantById(id) {
    return VARMAP.variants.find(v => v.id === id) || null;
  }
  function getSelectedOptions() {
    var out = {};
    document.querySelectorAll('.variant-input-wrap').forEach(fs => {
      var key = fs.getAttribute('data-index'); // "option1"|"option2"|"option3"
      var checked = fs.querySelector('input[type="radio"]:checked');
      if (key && checked) {
        var label = document.querySelector('label[for="'+ checked.id +'"]');
        out[key] = label ? label.getAttribute('muz-var-data') : encodeURIComponent(checked.value);
      }
    });
    return out;
  }
  function findVariantByOptions(opts) {
    return VARMAP.variants.find(v => {
      if (VARMAP.options_count >= 1 && encodeURIComponent(v.option1) !== opts.option1) return false;
      if (VARMAP.options_count >= 2 && encodeURIComponent(v.option2) !== opts.option2) return false;
      if (VARMAP.options_count >= 3 && encodeURIComponent(v.option3) !== opts.option3) return false;
      return true;
    }) || null;
  }
  function selectRadiosForVariant(v) {
    if (!v) return;
    [['option1', v.option1], ['option2', v.option2], ['option3', v.option3]].forEach(function(pair){
      var key = pair[0], val = pair[1];
      if (!val) return;
      var fs = document.querySelector('.variant-input-wrap[data-index="'+ key +'"]');
      if (!fs) return;
      // Prefer input by value (unencoded), then fallback to label’s muz-var-data
      var input = fs.querySelector('input[type="radio"][value="'+ CSS.escape(val) +'"]');
      if (!input) {
        var lbl = fs.querySelector('label[muz-var-data="'+ encodeURIComponent(val) +'"]');
        if (lbl) {
          var forId = lbl.getAttribute('for');
          input = document.getElementById(forId);
        }
      }
      if (input) input.click(); // triggers your existing handleVariantSelection
    });
  }
  function updateUrlToCurrentVariant() {
    var opts = getSelectedOptions();
    var v = findVariantByOptions(opts);
    if (v) {
      var url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url.toString());
    }
  }

  // On load: respect ?variant=ID
  document.addEventListener('DOMContentLoaded', function() {
    var vid = getUrlVariantId();
    if (vid) {
      var v = findVariantById(vid);
      if (v) {
        selectRadiosForVariant(v);
        // Setup variant thumbnail handlers after variant selection
        setTimeout(function() {
          setupVariantThumbnailHandlers();
          setFlickityViewportHeight();
        }, 200);
        return;
      }
    }
    // If no URL variant, ensure current selection applies your filtering once
    var checked = document.querySelector('.variant-input input[type="radio"]:checked');
    if (checked && typeof handleVariantSelection === 'function') {
      handleVariantSelection(checked);
      setTimeout(function() {
        setFlickityViewportHeight();
      }, 200);
    } else {
      // If no variant selected, still setup variant thumbnail handlers
      setTimeout(function() {
        setupVariantThumbnailHandlers();
        setFlickityViewportHeight();
      }, 200);
    }
  });

  // On any change/click, keep URL in sync
  document.querySelectorAll('.variant-input input[type="radio"]').forEach(function(radio) {
    radio.addEventListener('change', updateUrlToCurrentVariant);
    radio.addEventListener('click',  updateUrlToCurrentVariant);
  });

  // Support back/forward navigation
  window.addEventListener('popstate', function() {
    var vid = getUrlVariantId();
    var v = findVariantById(vid);
    if (v) selectRadiosForVariant(v);
  });
})();




// added by muzamil for the variant deselection



(function() {
  // Show everything (undo your filtering)
  function resetAllImages() {
    document.querySelectorAll('.muz-active-var').forEach(el => el.classList.remove('muz-active-var'));
    document.querySelectorAll('.hide').forEach(el => el.classList.remove('hide'));
    document.querySelectorAll('.parent-slide-sect-active').forEach(el => el.classList.remove('parent-slide-sect-active'));
    // show all Flickity dots if present
    document.querySelectorAll('.flickity-page-dots .dot').forEach(dot => { dot.style.display = 'inline-block'; });
    // optional: go to first slide
    if (window.productSlider && typeof productSlider.goToSlide === 'function') {
      productSlider.goToSlide(0);
    }
  }

  // Remove ?variant from URL
  function clearVariantFromUrl() {
    var url = new URL(location.href);
    url.searchParams.delete('variant');
    history.replaceState({}, '', url.toString());
  }

  // Delegate clicks on the little cross
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.variant-clear-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation(); // don't toggle the radio via the label

    // Find this option's fieldset
    var label = btn.closest('.variant__button-label');
    var fieldset = label && label.closest('.variant-input-wrap');
    if (!fieldset) { resetAllImages(); clearVariantFromUrl(); return; }

    // Uncheck the currently selected radio in this fieldset (if any)
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    if (checked) {
      checked.checked = false;
      // Some themes add "is-selected" to labels; clean it if present
      var lbl = fieldset.querySelector('label[for="'+ checked.id +'"]');
      if (lbl) lbl.classList.remove('is-selected');
      // Fire a change so theme UI updates (disabled Add to Cart, etc.)
      checked.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Reset gallery & URL regardless
    resetAllImages();
    clearVariantFromUrl();
  });

  // (Optional) mark selected label so you can style the cross only when selected
  function markSelectedLabels() {
    document.querySelectorAll('.variant-input-wrap').forEach(fs => {
      fs.querySelectorAll('.variant__button-label').forEach(l => l.classList.remove('is-selected'));
      var c = fs.querySelector('input[type="radio"]:checked');
      if (c) {
        var l = fs.querySelector('label[for="'+ c.id +'"]');
        if (l) l.classList.add('is-selected');
      }
    });
  }
  // hook into your existing selection changes
  document.querySelectorAll('.variant-input input[type="radio"]').forEach(r => {
    r.addEventListener('change', markSelectedLabels);
    r.addEventListener('click',  markSelectedLabels);
  });
  // initial mark
  document.addEventListener('DOMContentLoaded', markSelectedLabels);
})();
